<template>
  <!-- <div v-if = "td.length > 0" id="layout">
    <FLoader />
    <HeaderPartial />
    <div class="main-content">
      <div class="container mt-3">
        <router-view />
        <MyDialog />
      </div>
    </div>
    <FooterPartial />
  </div> -->
  <div v-if="user" ref="scrollContainer" id="scrollContainer" class="overflow-y-auto overflow-x-hidden"
    style="height: 100dvh;">
    <!-- <div v-if="isShowNewDesign">
      <router-view />
    </div> -->
    <div class="relative bg-[#FDF9EE] [word-break:break-word;]">
      <div
        class="absolute top-0 right-0 w-[360px] laptop:w-[350px] desktop:w-[450px] largeDesktop:w-[550px] laptop:z-[1]">
        <img src="../../assets/images/circle-bg.png" alt="Body Bg" class="w-full object-cover">
      </div>
      <!-- this icon only for dashboard -->
      <div v-if="$route.path === '/dashboard'" class="absolute bottom-0 right-0 w-[270px] hidden laptop:block">
        <img src="../../assets/images/circle-dashboard.png" alt="Body icon" class="w-full object-cover">
      </div>
      <div v-if="$route.path === '/dashboard'"
        class="absolute bottom-[35px] laptop:bottom-[45px] translate-x-[50%] 
        laptop:translate-x-[unset] 
        right-1/2 laptop:right-[unset] left-[unset] laptop:left-[0px] largeDesktop:-left-[60px] 
        w-[calc(100%-50px)] tablet:w-[calc(100%-400px)] laptop:w-[calc(60%-270px)] desktop:w-[calc(40%-300px)] largeDesktop:w-[calc(50%-290px)]">
        <img src="../../assets/images/men-img.png" alt="Body Bg" class="w-full object-cover">
      </div>
      <div v-else
        class="absolute mobile:bottom-0 mobile:z-[99] laptop:z-auto laptop:bottom-[45px] left-0 mobile:w-[90px] laptop:w-[300px] largeDesktop:w-[400px]">
        <img src="../../assets/images/men-img.png" alt="Body Bg" class="w-full object-cover">
      </div>
      <!-- <div class="absolute top-0 left-0 w-full h-full" style="z-index: -9">
        <img src="../../assets/images/body-Bg.png" alt="Body Bg" class="w-full h-full object-cover">
      </div> -->
      <FLoader />
      <headerNew v-if="isFromMobile != 1" />
      <div
        class="mobile:px-3 mobile:pt-28 laptop:pt-24 desktop:pt-16 largeDesktop:pt-20 largeDesktop:pl-10 laptop:pr-5 largeDesktop:pr-7 pb-4 relative"
        :class="{
          '!pt-[50px]': isFromMobile === 1,
          'mobile:!pb-10 laptop:!pb-[8rem] largeDesktop:!pt-28': $route.name == 'dashboard'
        }">
        <GlobaldashboardHead />
        <!-- {{ isCollapsed }} -->
          <div class="flex flex-col gap-[15px]">
            <proxyLogin v-if="user?.proxied_by"/>
            <div v-if="connectivityCheckDetails.connected == 0 && user.user.affiliate.affiliate_type != 'employee'"
              class="laptop:w-[850px] laptop:h-[50px] p-3 rounded-[10px] mx-[16px] laptop:mx-auto text-center flex justify-center items-center bg-[#EBAF4F]/30 border-[1px] !border-customYellow-100">
              <p class="m-0 text-xs tablet:text-base font-roboto">Your payment information is missing. <span
                  @click="stripClicked" class="text-[#2359A8] underline cursor-pointer">Click here </span>
                to connect your stripe account and start receiving commissions.</p>
            </div>
            <div v-else-if="connectivityCheckDetails.payout_enabled == 0 & user.user.affiliate.affiliate_type != 'employee'"
              class="largeDesktop:-mt-[10px] laptop:w-[850px] !p-3 rounded-[10px] mx-[16px] laptop:mx-auto text-center flex justify-center items-center bg-[#F8D7DA] border-[1px] !border-[#F5C2C7]">
              <p class="m-0 text-xs tablet:text-base font-roboto">Your Stripe account is connected, but payouts are
                currently disabled. <span @click="payoutStripClicked()"
                  class="text-[#2359A8] underline cursor-pointer">Click
                  here
                </span>
                to submit the remaining information in Stripe Express to activate payouts.</p>
            </div>
          </div>
        <WelcomeCard :heading="'Welcome ' + (user ? user.user.full_name : '')"
          :text="'Let’s make today productive and achieve some great results'" />
        <div class="flex flex-grow items-start gap-5 ">
          <div class="flex items-start largeDesktop:gap-5 laptop:gap-4 mt-10 w-full transition duration-800" :class="{
            '!gap-0': $route.name === 'globalSearch' && isCollapsed
          }">
            <SidebarNavigation v-if="isSideMenuShow" @sidebar-collapse="handleSidebarCollapse"
              class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" :class="{
                '!w-0': $route.name === 'globalSearch' && isCollapsed
              }" />
            <!-- <sidebar class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" /> -->

            <!-- Main Content -->
            <div class="flex-1 min-w-0 transition duration-1500" :class="{
              'w-[calc(100vw-320px)] mx-auto': !isCollapsed,  // 100vw - 64 (16rem = 256px)
              'mobile:w-auto mobile:flex-1 desktop:w-[calc(100vw-500px)] largeDesktop:w-[calc(100vw-700px)] mx-auto desktop:flex-none': $route.name === 'globalSearch' && isCollapsed,
            }">
              <!-- <dashboard /> -->
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
      <FooterPartial />
      <!-- <div class="main-content">
          <div class="container mt-3">
            <router-view />
            <MyDialog />
          </div>
        </div> -->
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
import {
  mapGetters, mapActions
} from "vuex";
import proxyLogin from "../../components/partialComponent/proxyLogin.vue";
import headerNew from "../../components/layouts/header/header_new.vue";
import GlobaldashboardHead from "../globaldashboardHead.vue";
import SidebarNavigation from "../sidebarNavigation.vue";
import WelcomeCard from "../welcomeCard.vue";
import FooterPartial from "./footer/FooterPartial";
import sidebar from "../nest_components/omega_sidebar/sidebar.vue";
// import dashboard from "../../views/dashboard/dashboard.vue";
import { useToast } from "vue-toastification";
import router from "../../router";
import Dashboard from "../../views/myHappyHome/dashboard.vue";
import { startTour, isTourActive } from "../../services/tourService";
const toast = useToast();

export default {
  name: "Layout",

  components: {
    proxyLogin,
    headerNew,
    GlobaldashboardHead,
    WelcomeCard,
    SidebarNavigation,
    FooterPartial,
    // sidebar
    // dashboard
  },

  data() {
    return {
      td: '',
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      isCollapsed: false, // or true, depending on your default state
    };
  },

  computed: {
    ...mapGetters(["connectivityCheckDetails", "connectivityInitDetails", "updateStripeDetails", "stripConnect", "stripLogin"]),

    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },


    isSideMenuShow() {
      return this.$route.name != 'dashboard';
    }

  },

  mounted() {
    this.scrollToTop();
    let obj = this.$route.query
    if (this.$route.name != 'register') {
      if (obj.stripe_account_link == 'success') {
        this.stripeConnect()
      }
      else {
        this.getConnectivityCheckDetails()
      }
      this.initTour();
    }
  },

  watch: {
    connectivityInitDetails: function () {
      this.$dialog.show({
        title: "Redirecting to Stripe",
        text: "You’re about to continue to Stripe to complete your account setup.",
        onConfirm: () => {
          if (this.connectivityInitDetails.redirect_url.length > 0) {
            window.open(this.connectivityInitDetails.redirect_url, '_blank');
          }
        },
      });
    },

    $route() {
      this.scrollToTop();
      this.initTour();
    },
    stripConnect: function () {
      toast.success(this.stripConnect.message);
      this.getProfile({})
    },

    stripLogin: function () {
      if (this.stripLogin.redirect_url.length > 0) {
        window.open(this.stripLogin.redirect_url, "_blank");
      }
    },

    '$route.path': function () {
      // Re-trigger tour check on navigation if needed
      this.initTour();
    },

    apiCallback: function (val) {
      // If API finished loading, try starting/resuming the tour
      if (val === false) {
        this.initTour();
      }
    },

  },

  methods: {
    ...mapActions(["getConnectivityCheckDetails", "getConnectivityInitDetails", "getUpdateStripeDetails", "stripeConnect", "getProfile", "stripeLoginConnect"]),

    handleSidebarCollapse(isCollapsed) {
      this.isCollapsed = isCollapsed;
    },
    scrollToTop() {
      const container = document.getElementById('scrollContainer');
      if (container) container.scrollTop = 0;
    },
    stripClicked() {
      this.getConnectivityInitDetails()
    },

    payoutStripClicked() {
      this.stripeLoginConnect()
    },

    updateStripe() {
      const params = this.$route.query
      console.log("params", params.stripe_account_link)
      if (params.stripe_account_link == 'success') {

      }
    },

    async initTour() {
      // Don't even attempt if already completed or already running
      if (localStorage.getItem('my_happy_home_tour_completed') === 'true') return;

      // The tour service now handles its own waiting for elements and API status
      await startTour(this.$router, this.$store);
    },

  },
};
</script>
